module.exports = __webpack_public_path__ + "static/media/b3.596f66ef.jpg";